module.exports = __webpack_public_path__ + "static/media/bhs.27bbbdde.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/experiences/bhs.png
// module id = 103
// module chunks = 0